// src/components/CapActionsMenu.jsx
//
// Menu de ações "overflow" (botão ☰) para recolher ações secundárias do header.
// Fecha ao clicar fora e com ESC. Usa render-prop: children(close) recebe a
// função para fechar o menu após acionar um item.

import React, { useState, useRef, useEffect } from 'react';
import { FaBars, FaChevronDown } from 'react-icons/fa';
import './CapActionsMenu.css';

export default function CapActionsMenu({ label = 'Ações', count = 0, children }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    if (!open) return;
    const onClick = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    const onKey   = (e) => { if (e.key === 'Escape') setOpen(false); };
    document.addEventListener('mousedown', onClick);
    document.addEventListener('keydown', onKey);
    return () => {
      document.removeEventListener('mousedown', onClick);
      document.removeEventListener('keydown', onKey);
    };
  }, [open]);

  const close = () => setOpen(false);

  return (
    <div className="cap-menu" ref={ref}>
      <button
        type="button"
        className={`cap-menu-trigger ${open ? 'open' : ''}`}
        onClick={() => setOpen((o) => !o)}
        title="Mais ações"
        aria-haspopup="menu"
        aria-expanded={open}
      >
        <FaBars className="cap-menu-trigger-icon" />
        <span className="cap-menu-trigger-label">{label}</span>
        {count > 0 && <span className="cap-menu-trigger-badge">{count}</span>}
        <FaChevronDown className="cap-menu-caret" />
      </button>

      {open && (
        <div className="cap-menu-dropdown" role="menu">
          {typeof children === 'function' ? children(close) : children}
        </div>
      )}
    </div>
  );
}